import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de création d'un client API partenaire
 * (`POST /ApiClients/add`, guide §6.1 — endpoint gateway).
 * `scopes` est saisi en texte (séparé par des virgules ou des espaces) et
 * éclaté en tableau au submit.
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createApiClientSchema = () =>
  z.object({
    name: z.string().trim().min(1, { message: t("requiredFieldError") }),
    rateLimitPerMinute: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .int({ message: t("invalidFieldError") })
      .min(1, { message: t("invalidFieldError") }),
    scopes: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type ApiClientFormValues = z.infer<
  ReturnType<typeof createApiClientSchema>
>;

/**
 * Schéma du formulaire de mise à jour des scopes
 * (`PUT /ApiClients/{id}/scopes`) — même saisie texte éclatée au submit.
 */
export const createApiClientScopesSchema = () =>
  z.object({
    scopes: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type ApiClientScopesFormValues = z.infer<
  ReturnType<typeof createApiClientScopesSchema>
>;

/** Éclate une saisie texte de scopes (virgules / espaces / retours ligne). */
export const parseScopesInput = (raw: string): string[] =>
  raw
    .split(/[\s,;]+/)
    .map((scope) => scope.trim())
    .filter(Boolean);
